// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__U7UOL","spinner":"styles_spinner__rrmUn"};